import type {RecordingStatus} from 'nutshell-graphql-types';

export const getRecordingStatusText = (status: RecordingStatus): string => {
    switch (status) {
        case 'NONE':
            return 'not recorded';
        case 'PROCESSING':
            return 'processing';
        case 'PROCESSED':
            return 'recorded';
        case 'STARTED':
            return 'recording';
        default:
            return 'unknown';
    }
};
